import { render, staticRenderFns } from "./ypcxListAction.vue?vue&type=template&id=6c27f1b7&scoped=true"
import script from "./ypcxListAction.vue?vue&type=script&lang=js"
export * from "./ypcxListAction.vue?vue&type=script&lang=js"
import style0 from "./ypcxListAction.vue?vue&type=style&index=0&id=6c27f1b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c27f1b7",
  null
  
)

export default component.exports